


export enum PlaylistEnum {
    SEMINARIO = 'SEMINARIO',
    PROMOVER_ALFABETIZACAO = 'PROMOVER_ALFABETIZACAO',



    NOT404 = 'NOT404'
}